import React from "react";
import type { TemplatePayload } from "../types";
import { Countdown } from "./components/Countdown";

export interface MonoTemplateProps extends TemplatePayload {
  onDismiss: () => void;
  onReload: () => void;
}

export const MonoTemplate: React.FC<MonoTemplateProps> = ({
  mode,
  remoteVersion,
  localVersion,
  breaking,
  autoReloadInMs,
  instructions,
  projectName,
  onDismiss,
  onReload
}) => {
  const showSteps = mode === "manual"; // mostrar pasos solo cuando hubo problema de actualización
  const msToAuto = autoReloadInMs ?? 60_000;

  return (
    <div
      data-react-checker-version
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 2147483647,
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-start",
        pointerEvents: "none"
      }}
    >
      <div
        style={{
          margin: 24,
          maxWidth: 360,
          background: "#1f1f1f",
          color: "#ffffff",
          borderRadius: 12,
          boxShadow: "0 12px 32px rgba(0,0,0,0.35)",
          padding: 20,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          pointerEvents: "auto"
        }}
      >
        <h2 style={{ margin: "0 0 12px", fontSize: 18, fontWeight: 600 }}>
          {mode === "manual"
            ? "No pudimos actualizar automáticamente"
            : breaking
            ? "Hay una actualización crítica"
            : "Hay una nueva versión disponible"}
        </h2>
        <p style={{ margin: "0 0 16px", fontSize: 14, lineHeight: 1.45 }}>
          {mode === "manual"
            ? `Sigue los pasos para forzar la actualización de ${projectName}.`
            : breaking
            ? (
                <>
                  Esta página se actualizará automáticamente en <Countdown initialMs={msToAuto} />. También puedes actualizar ahora.
                </>
              )
            : "Presiona actualizar para recargar y obtener la versión más reciente."}
        </p>
        <p style={{ margin: "0 0 16px", fontSize: 13, color: "#d0d0d0" }}>
          Versión actual detectada: <strong>{localVersion || "desconocida"}</strong>
          <br />
          Nueva versión disponible: <strong>{remoteVersion}</strong>
        </p>

        {showSteps && (
          <>
            <p style={{ margin: "0 0 8px", fontSize: 13, fontWeight: 600 }}>
              {`Pasos sugeridos (${instructions.headline})`}
            </p>
            <ul
              style={{
                margin: "0 0 16px 16px",
                padding: 0,
                fontSize: 13,
                lineHeight: 1.5
              }}
            >
              {instructions.steps.map(step => (
                <li key={step} style={{ marginBottom: 6 }}>
                  {step}
                </li>
              ))}
            </ul>
          </>
        )}

        <div
          style={{
            display: "flex",
            gap: 8,
            justifyContent: mode === "manual" ? "flex-end" : "space-between"
          }}
        >
          {!breaking && (
            <button
              type="button"
              style={{
                background: "transparent",
                color: "#fff",
                border: "1px solid #fff",
                borderRadius: 6,
                padding: "6px 12px",
                cursor: "pointer"
              }}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                onDismiss();
              }}
            >
              {mode === "manual" ? "Entendido" : "Lo haré luego"}
            </button>
          )}

          {mode !== "manual" && (
            <button
              type="button"
              style={{
                background: "#dc202d",
                color: "#fff",
                border: "1px solid #dc202d",
                borderRadius: 6,
                padding: "6px 14px",
                cursor: "pointer"
              }}
              onClick={e => {
                e.preventDefault();
                e.stopPropagation();
                onReload();
              }}
            >
              Actualizar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MonoTemplate;
